import gameset from "./gameset";
import {load} from "../framework/src/loader/scriptLoader";

async function init() {
    await load(gameset);
    let main = await import("./main");
    main.run(gameset);
}

init();